import { useSelector } from "react-redux";
import * as  R from 'ramda';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectOrdersCreatedItem } from "../../../../../redux/orders/selector";
import { cargoLeads } from "../../../../../redux/cargo-lead/action";
import { currency, getBodyType } from "../../../../../common/services/common.service";
import { format } from "../../../../../common/services/date.service";
import { selectAnnouncementsListItems } from "../../../../../redux/announcements/selector";
import _ from "lodash";
import { announcements } from "../../../../../redux/announcements/action";
import PageLoader from "../../../../../components/PageLoader";

const AgentCargoOrderDetailsMobile = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const orderDetails = useSelector(selectOrdersCreatedItem)
    const announcementsList = useSelector(selectAnnouncementsListItems)
    let fareAmount = _.find(announcementsList.result.items, ['Title', 'fareAmount']);

    const back = () => {
        dispatch(cargoLeads.resetAction({ actionType: 'create' }))
        navigate('/transport-agent/bookings/cargo')
    }

    const orderData = orderDetails?.result?.items?.Records[0]?.message?.order

    console.log(orderData, 'orderData')
    useEffect(
        () => {
            dispatch(announcements.list({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/list`,
                entity: 'announcements',
                jsonData: {}
            }))
        },
        []
    );
    return (
        <>
            {announcementsList?.isLoading ? <PageLoader /> :
                <div className="py-10 px-4 md:px-20 lg:px-40 bg-white min-h-screen">
                    {/* Back Button */}
                    <div className="mb-6">
                        <button
                            onClick={back}
                            type="button"
                            className="text-primary font-medium text-sm md:text-base flex items-center gap-1"
                        >
                            <span>&larr;</span> Back To Booking
                        </button>
                    </div>

                    {/* Heading */}
                    <div className="text-xl md:text-2xl font-bold text-center mb-6 md:mb-10">
                        Thank you for Booking
                    </div>

                    {/* Booking Info */}
                    <div className="flex flex-col  gap-3  mb-6">
                        <div className="space-y-1 text-sm md:text-base">
                            <div className="font-medium">Booking ID: {orderData?.id}</div>
                            <div className="font-medium">Tracking No: {orderData?.fulfillments[0]?.tracking_no}</div>
                            <div className="font-medium">
                                Schedule Date: {format(orderData?.items[0]?.time?.timestamp)}
                            </div>
                        </div>

                    </div>

                    <div className="border-b border-gray-200 mb-8"></div>
                    {/* Details Section */}
                    <div className="flex justify-center text-center">
                        <div className="w-full  space-y-6">
                            {/* Row 1: Vehicle Type + Product Type */}
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <div className="font-semibold text-gray-700 text-sm md:text-base">Vehicle Type</div>
                                    <div className="text-sm md:text-base">
                                        {getBodyType(orderData?.fulfillments[0]?.vehicle?.VehicleBodyTypeId)}
                                    </div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-700 text-sm md:text-base">Product Type</div>
                                    <div className="text-sm md:text-base">
                                        {orderData?.["@ondc/org/linked_order"]?.items?.[0]?.CategoryName}
                                    </div>
                                </div>
                            </div>

                            {/* Row 2: Payment Type + Amount */}
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <div className="font-semibold text-gray-700 text-sm md:text-base">Payment Type</div>
                                    <div className="text-sm md:text-base">{orderData?.payment?.method}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-700 text-sm md:text-base">Amount</div>
                                    <div className="text-sm md:text-base">{currency(orderData?.quote?.price?.value)}</div>
                                </div>
                            </div>

                            {/* Row 3: Total Distance */}
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <div className="font-semibold text-gray-700 text-sm md:text-base">Total Distance</div>
                                    <div className="text-sm md:text-base">{orderData?.quote?.TotalDistance} Km</div>
                                </div>
                            </div>

                            {/* Pickup Address (full width) */}
                            <div>
                                <div className="font-semibold text-gray-700 text-sm md:text-base">Pickup Address</div>
                                <div className="text-xs md:text-sm leading-relaxed text-gray-600">
                                    {orderData?.fulfillments[0]?.start?.location?.address?.locality},{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.city} -{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.area_code},{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.state},{" "}
                                    {orderData?.fulfillments[0]?.start?.location?.address?.country}
                                </div>
                            </div>

                            {/* Drop Address (full width) */}
                            <div>
                                <div className="font-semibold text-gray-700 text-sm md:text-base">Drop Address</div>
                                <div className="text-xs md:text-sm leading-relaxed text-gray-600">
                                    {orderData?.fulfillments[0]?.end?.location?.address?.locality},{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.city} -{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.area_code},{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.state},{" "}
                                    {orderData?.fulfillments[0]?.end?.location?.address?.country}
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="border-b border-gray-200 my-8"></div>

                    {/* Note */}
                    <div className="text-sm md:text-base text-gray-700 leading-relaxed">
                        <span className="font-semibold">Note:</span> {fareAmount?.Description}
                    </div>
                </div>

            }
        </>

    );
};

export default AgentCargoOrderDetailsMobile;


